import { Backdrop, Box, Button, Divider, IconButton, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { CstmTextField } from "../CstmTextField";
import { TxtEmail } from "../../../core/global/Validation";
import { env } from "../../Env";
import { rqx } from "../../request/API";
import { CloseBtn, SuccessIcon, Warning } from "../Icons";
import { Buttons } from "../Buttons";
import { PreLoader } from "../../loader/PreLoader";
import { avatarstylesx } from "../../styling/global";
import OTP from "react-otp-input";
import AcadLogo from "../../../assets/images/logos/main/pof-acad-128x128.png"
import { SnakeLoader } from "../../loader/SnakeLoader";

export const SuccessAlert = (props) => {
    const { success_alert_State, text, actionType } = props;
 
    const [alrt] = useState({vertical:"top", horizontal:"center"}) 
    const { vertical, horizontal } = alrt;
    
    return (
        <Snackbar key={vertical + horizontal} anchorOrigin={{ vertical, horizontal }} open={success_alert_State.successOpen.data} autoHideDuration={2000} onClose={() => success_alert_State.successOpen.set(false)} >
            <Box m={3} mt={10} borderRadius={3} bgcolor="#00BE81" fontSize={16} display="flex" justifyContent="center" alignItems="center" minHeight="44px" color="#ffffff" px={2}>
                <Box display="flex" justifyContent="center" alignItems="center"> 
                    <SuccessIcon/><Box px={1}>{text} {actionType === "Update" ? "updated" : (actionType === "Skip" ? "skip" : (actionType === "removed" ? "removed" : (actionType === "recently" ? "restored" : "uploaded") ) ) }. </Box>
                </Box>   
            </Box>
        </Snackbar>
    )
}

//Check Email
export const ConfirmationEmail = (props) => {
    const { isOpen, isClose, vc, vc2 ,disabled = false, email} = props;
    const [dataEmail, setDataEmail] = useState({email_address:""})
    const [errors, setErrors] = useState(false)
    const [emailExist, setEmailExist] = useState(false)
    const handleOnChange = (e) => {
        const { name, value } = e.target;
        const data = {...dataEmail};
        if(TxtEmail(value)){
            setErrors(false)
        } else {
            setErrors(true)
        }
        data[name] = value;
        setDataEmail(data)
        email.set(data)        
    }
    const handleCloseModal = (e) => {
        e.preventDefault();
        setDataEmail({email_address:""})
        isClose.set(false);
    };
    const proceedBtn = async(e) => {
        if(errors === false){
            let attempt = await rqx.post(
                `https://r307lvbgjd.execute-api.ap-southeast-1.amazonaws.com/dev/psl/su/attempt/email`, 
                {account: dataEmail.email_address, ref: '1'}, 
                {'x-api-key': 'Op4jiIaYM08j9g05gy2wcaYSsMI0i9P3qYwtlgrj'}
            )
            if (attempt.msg === "delivered") {
                setEmailExist(false)
                vc.set(attempt.vc)
                vc2.set(true)
                isClose.set(false);
            } else {
                setEmailExist(true)
            }
        }
    }
    return (
        <Backdrop open= {isOpen} style={{zIndex: "1301"}}>
            <Box width="600px" height="320px" minHeight="320px" bgcolor="#ffffff" borderRadius="13px" display="flex" flexDirection="column" justifyContent="space-around" alignItems="center">
                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" px={3}>
                    <Box fontSize={16} fontWeight={500}>Email Verification</Box>
                    <Box position="relative" top={-16} right={-16}>
                        <IconButton onClick={(e)=>handleCloseModal(e)}><CloseBtn /></IconButton>
                    </Box>
                </Box>
                <Box px={3} width="100%">
                    <Box fontSize={14} color="#537192" mb={1}>Email*</Box>
                    <CstmTextField fullWidth onChange={(e)=>handleOnChange(e)} variant="outlined" name="email_address" value={dataEmail.email_address} error={(dataEmail.email_address === "" || dataEmail.email_address !== "") && (errors || emailExist) && (true)} helperText={(dataEmail.email_address === "") && errors ? ("This field is required") : dataEmail.email_address !== "" && errors ? ("Invalid Email") : emailExist === true && ("Email is already exist") } />
                </Box>
                <Box width= "180px" margin= "0 8px">
                    <Buttons disabled={disabled} height="48px" event= { (e) => proceedBtn(e) } variant="contained" color="primary" width="100%" text={disabled ? <PreLoader show={false} length={4} /> : "Submit"}/>
                </Box>
            </Box>
        </Backdrop>
    )
}

//Verification Code
export const VerificationCode = (props) => {
    const { isOpen, vc , session, email, success, /* wps, identifier, domain */} = props;
    const [dataVC, setDataVC] = useState({vc:"", stat: false, msg:""})
    const [loader, setLoader] = useState(false)
    const proceedBtn = async(e) => {
        setLoader(true)
        if(vc.data === dataVC.vc){
            let attempt = await rqx.post(`<<global>>/${env()==="local"?"dev":env()}/account/update`, {vam: "email", aid: session.data.ainfo.aid, account: email.data.email_address})
            if(attempt.msg === "success") {
                session.data.ainfo.email = email.data.email_address
                // if(identifier === "summary") {
                //     window.location.href = `${domain.url}/api/sso/account/auth?ainfo=${encodeURIComponent(JSON.stringify(session.data.ainfo))}&account_details=${wps.accountDetails}&prclicense=${wps.prclicense}`
                // }else {
                //     window.location.href = `${domain.url}/api/acad/redirect/new-training?ainfo=${encodeURIComponent(JSON.stringify(session.data.ainfo))}&account_details=${wps.accountDetails}&link=${wps.link}&prclicense=${wps.prclicense}`
                // }
            }
            setLoader(false)
        }else {
            const inputs = {...dataVC}
            inputs["step"] = 2
            inputs["msg"] = "OTP Code is incorrect"
            inputs["stat"] = true
            setDataVC(inputs)
        }
        setTimeout(() => {
            setLoader(false)
        }, 2000);
    }
    let time = 360
    const [resend, setResend] = useState(360)
    const [resendStat, setResendStat] = useState({value: 0, msg: "Resend code"})

    useEffect(() => {
        if (resendStat.value === 0) {
            setResendStat({...resendStat, value: 1, msg: ""})
            cd()
        }

        let otpkey = document.getElementsByClassName("otp-inputs")
        for (var i=0; i < otpkey.length; i++) {
            otpkey[i].onkeypress = function(e){
                if (e.key === "Enter") {
                    proceedBtn()
                }
            }
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cd = () => {
        let countdown = setInterval(() => {
            time--
            setResend(time)
            if (time <= 0) {
                setResendStat({...resendStat, value: 2, msg: "Resend code"})
                clearInterval(countdown)
            }
        }, 1000);
    }

    const resendCodeHandler = async () => {
        setResendStat({...resendStat, msg: "Sending. . ."})
        let attempt = await rqx.post(`https://r307lvbgjd.execute-api.ap-southeast-1.amazonaws.com/${env()}/psl/su/attempt/email`, {account: email.data.email_address, ref: "1"})
        if (attempt.msg === "delivered") {
            success.successOpen.set(true)
            time = 180
            setResend(180)
            vc.set(attempt.vc)
            setTimeout(() => {
                cd()
                success.successOpen.set(false)
                
            }, 500);

        }
    }
    return (
        <>
            <Backdrop open= {isOpen} style={{zIndex: "1301"}}>
                {/* <Box display="flex" flexDirection="column" alignItems="center" width="100%"> */}
                <Box width="600px" height="500px" minHeight="500px" bgcolor="#FFFFFF" borderRadius="13px" display="flex" flexDirection="column" justifyContent="space-around" alignItems="center" px={3}>
                    <Box display="flex" alignItems="center" pb={5} pt={3}>
                        <Box sx={avatarstylesx(AcadLogo, 40, 40)} />
                        <Box fontSize={24} ml={1.5}>POF<b>Academy</b></Box>
                    </Box>
                    <Box display="flex" flexDirection="column" width="100%" alignItems="center">
                        <Box textAlign="center" justifyContent="center" mb={3} mx={1}>a verification code has been sent to your email account.</Box>
                        <Box pb={2} display="flex" flexDirection="column" justifyContent="center">
                            <OTP inputStyle={`otp-inputs ${dataVC.stat?"bg-otp-mismatched":"bgpsl"}`} value={dataVC.vc} onChange={(e)=>setDataVC({...dataVC, stat: false, vc: e, mgs:""})} isInputNum={true} numInputs={6} /* separator={<span>-</span>} */ />
                            <Box color="error.main" fontSize={13} textAlign="center"><b>{dataVC.stat === true && dataVC.msg }</b></Box>
                        </Box>
                        <Box width= "180px" margin= "0 8px">
                            <Buttons disabled={loader} height="48px" event= { (e) => proceedBtn(e) } variant="contained" color="primary" width="100%" text={loader === true ? <SnakeLoader bg="#0070EF" size= "16px" distance= "2px" /> : "Verify"}/>
                        </Box>
                        <Box textAlign="center" pb={4} fontSize={13} mt={3}>
                            <Box textAlign="center" pr={0.5}>Didn"t receive the verification code?</Box>
                            {
                                resendStat.value!==2 ? (
                                    <Box color="primary.main"><b>Resend code after {resend} sec.</b></Box>
                                ) : (
                                    <Box color="primary.main" onClick={resendCodeHandler} className="c-pointer"><b>{resendStat.msg}</b></Box>
                                )
                            }
                        </Box>
                    </Box>
                </Box>
            </Backdrop>
            <SuccessAlert success_alert_State={success} text="Successfully " actionType={"Verified"} /> 
        </>
    )
}

export const SuccessSaving = (props) => {
    const { successSaving, setSuccessSaving, text } = props;
 
    const [alrt] = useState({vertical:'top', horizontal:'center'}) 
    const { vertical, horizontal } = alrt;
    
    return (
        <Snackbar key={vertical + horizontal} anchorOrigin={{ vertical, horizontal }} autoHideDuration={2000} open={successSaving}  onClose={() => setSuccessSaving(false)} >
            <Box m={3} mt={10} borderRadius={3} bgcolor="#00BE81" fontSize={16} display="flex" justifyContent="center" alignItems="center" minHeight="44px" color="#ffffff" px={2}>
                <Box display="flex" justifyContent="center" alignItems="center"> 
                    <SuccessIcon/><Box px={1}>{text}. </Box>
                </Box>   
            </Box>
        </Snackbar>
    )
}

export const QuitTest = ({test, closeHandler}) => {
    return (
        <Backdrop sx={{ justifyContent: 'center', alignItems: 'center', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={test.data.toggled}>
            <Box bgcolor="#fff" borderRadius={3} width={400} p="24px">
                <Box display="flex" alignItems="center">
                    <Warning />
                    <Box ml={1} fontSize="P-500" color="#283745">Quit {test.data.name}?</Box>
                </Box>
                <Box my={2}><Divider sx={{ borderColor: '#E9F0FB' }} /></Box>
                <Box fontSize="P-300" color="#283745">Are you sure want to quit the {test.data.name} before completing it?</Box>
                {/* <Box display="flex" flexDirection="column" textAlign="center" alignItems="center" p={3} py={4} width="100%">
                    asdas
                </Box> */}
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Box component={Button} mr="7px" sx={{height:'44px', width:'59px', bgcolor:'#FFFFFF', border:'1px solid #E9F0FB', color:'#283745', borderRadius:'5px', ':hover':{bgcolor:'#1893F1', color:'#FFFFFF'} }} onClick={()=>closeHandler(false)}>No</Box>
                    <Box component={Button} ml="7px" sx={{height:'44px', width:'108px', bgcolor:'#E3F2FD', border:'1px solid #E9F0FB', color:'#1893F1', borderRadius:'5px', ':hover':{bgcolor:'#1893F1', color:'#FFFFFF'} }} onClick={()=>closeHandler(false, 'training')}>Yes, Quit</Box>
                </Box>
            </Box>
        </Backdrop>

    )
}

export const NotifProfession = ({open, handleProceed, color="primaryBiz"}) => {
    return (
        // <Backdrop sx={{ justifyContent: 'center', alignItems: 'center', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
        <Backdrop sx={{ justifyContent: 'center', alignItems: 'center', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
            <Box bgcolor="#fff" borderRadius={3} width={400} p="24px">
                <Box display="flex" alignItems="center">
                    <Warning stroke="#F44336" width="40px" height="40px" />
                    <Box ml={1} fontWeight={600} fontSize="18px" color="#F44336">
                        Action Required
                    </Box>
                </Box>
                <Box my={2}><Divider sx={{ borderColor: '#E9F0FB' }} /></Box>
                <Box fontSize="16px" color="#283745" fontWeight={500}>
                    Please update your professional information immediately.
                    </Box>
                <Box mt={1} color="#6B7280" fontSize="14px">
                    Keeping your details up to date ensures uninterrupted access to our services.
                </Box>
                <Box my={2}><Divider sx={{ borderColor: '#E9F0FB' }} /></Box>
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Buttons event={(e)=>handleProceed(e)} margin="0px 12px 0px 0px " borderRadius="8px" variant="contained" color={color} width="120px" height="48px" text="Update Now"/>
                </Box>
            </Box>
        </Backdrop>
    )
}